import { render } from "./TrashView.vue?vue&type=template&id=12452982&scoped=true"
import script from "./TrashView.vue?vue&type=script&lang=js"
export * from "./TrashView.vue?vue&type=script&lang=js"

import "./TrashView.vue?vue&type=style&index=0&id=12452982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12452982"]])

export default __exports__